import { render, staticRenderFns } from "./ActivityLogSettings.vue?vue&type=template&id=79cfc2f9&"
import script from "./ActivityLogSettings.vue?vue&type=script&lang=js&"
export * from "./ActivityLogSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports